import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UserInteractionContextType {
  hasUserInteracted: boolean;
  markUserInteraction: () => void;
  isFirstChatOpen: boolean;
  markFirstChatOpen: () => void;
}

const UserInteractionContext = createContext<UserInteractionContextType | undefined>(undefined);

interface UserInteractionProviderProps {
  children: ReactNode;
}

export const UserInteractionProvider: React.FC<UserInteractionProviderProps> = ({ children }) => {
  const [hasUserInteracted, setHasUserInteracted] = useState(false);
  const [isFirstChatOpen, setIsFirstChatOpen] = useState(true);

  const markUserInteraction = () => {
    if (!hasUserInteracted) {
      console.log('User interaction detected - enabling autoplay');
      setHasUserInteracted(true);
    }
  };

  const markFirstChatOpen = () => {
    if (isFirstChatOpen) {
      console.log('First chat open detected');
      setIsFirstChatOpen(false);
      markUserInteraction(); // Opening chat counts as user interaction
    }
  };

  return (
    <UserInteractionContext.Provider value={{
      hasUserInteracted,
      markUserInteraction,
      isFirstChatOpen,
      markFirstChatOpen
    }}>
      {children}
    </UserInteractionContext.Provider>
  );
};

export const useUserInteraction = (): UserInteractionContextType => {
  const context = useContext(UserInteractionContext);
  if (context === undefined) {
    throw new Error('useUserInteraction must be used within a UserInteractionProvider');
  }
  return context;
};